import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KYMW1313Component } from './kymw1313.component';
import { KYMW1313RoutingModule } from './kymw1313.routing.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { GetSetPlanPromotionGoodsListService } from './api-services/get-set-plan-promotion-goods-list.service';
import { FormsModule } from '@angular/forms';

/**
 * セット企画検索画面 モジュール設定クラス
 *
 * @export KYMW1313Module
 * @class KYMW1313Module
 */
@NgModule({
  imports: [
    CommonModule,
    KYMW1313RoutingModule,
    PlessSharedModule,
    AppCommonsModule,
    WjNavModule,
    WjGridModule,
    FormsModule,
  ],
  declarations: [
    KYMW1313Component,
  ],
  providers: [
    GetSetPlanPromotionGoodsListService,
  ],
})

export class KYMW1313Module { }
